// extracted by mini-css-extract-plugin
export var wrapper = "CardSix-module--wrapper--1V632";
export var bgVideo = "CardSix-module--bg-video--2kug-";
export var content = "CardSix-module--content--2bWfR";
export var white = "CardSix-module--white--3hJ4j";
export var linkWrapper = "CardSix-module--link-wrapper--3Vcnx";